const { parent } = window;
const CMD_CALL_GA = 'call-ga';
const CMD_PUSH_DATALAYER = 'push-dl';

/**
 * callParentGA
 * @description Issue a request to call google analytics (ga) call in the parent page
 * @param {Varies} - any of the arguments normally sent to ga() can be sent to this function
 */
export function callParentGA(...args) {
  var arrayArgs = []
  for (var arg in args) {
    arrayArgs.push(arguments[arg]);
  }
  parent.postMessage({
    command: CMD_CALL_GA,
    args: arrayArgs
  }, '*');
}

/**
* pushParentDL
* @description Issue a request to push data to the GTM datalayer in the parent page
* @param {Object} data - the object to be sent to GTM
*/
export function pushParentDL(data) {
  parent.postMessage({
    command: CMD_PUSH_DATALAYER,
    args: [data]
  }, '*');
}
